// Helper to get current post/page ID
function get_current_post_id() {
	if (document.body && document.body.dataset.postId) {
		return parseInt(document.body.dataset.postId, 10) || 0;
	}
	return 0;
}

document.addEventListener('DOMContentLoaded', () => {

	// --- Constants & Config ---
	if (typeof origoSaleData === 'undefined') {
		console.error("origoSaleData is missing. Fire sale script aborting.");
		return;
	}

	const apiUrl = origoSaleData.apiUrl;

	// Date/Time constants
	const dutchMonths = {
		'januari': 0,
		'februari': 1,
		'maart': 2,
		'april': 3,
		'mei': 4,
		'juni': 5,
		'juli': 6,
		'augustus': 7,
		'september': 8,
		'oktober': 9,
		'november': 10,
		'december': 11
	};
	const dutchDays = [
		"Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag",
		"Zaterdag"
	];
	const dutchMonthNames = [
		"januari", "februari", "maart", "april", "mei", "juni", "juli",
		"augustus", "september", "oktober", "november", "december"
	];

	const now = new Date();
	const currentYear = now.getFullYear();

	// --- Helper Functions ---
	const parseDateString = (dateStr) => {
		if (!dateStr) return null;
		if (dateStr.includes(' ')) {
			const [datePart, timePart] = dateStr.split(' ');
			const [year, month, day] = datePart.split('-').map(Number);
			const [hours, minutes] = timePart.split(':').map(Number);
			return new Date(year, month - 1, day, hours, minutes, 0);
		}
		return new Date(dateStr);
	};

	// fetchWithRetries removed -> using window.OrigoApi

	const generateFallbackDays = (startDate, endDate) => {
		const days = [];
		let currentDate = new Date(startDate);
		if (isNaN(currentDate.getTime())) return [];

		currentDate.setHours(0, 0, 0, 0);
		const endDateNormalized = new Date(endDate);
		if (!isNaN(endDateNormalized.getTime())) endDateNormalized.setHours(23, 59, 59, 999); else endDateNormalized.setDate(currentDate.getDate() + 7);

		let limit = 0;
		while (currentDate <= endDateNormalized && limit < 60) {
			const dayIndex = currentDate.getDay();
			if (dayIndex !== 0) { // Skip Sunday
				days.push({
					day_name: dutchDays[dayIndex],
					day_number: currentDate.getDate(),
					month_name: dutchMonthNames[currentDate.getMonth()],
					date: currentDate.toISOString().split('T')[0],
					close_time: null,
					is_future_day: false
				});
			}
			currentDate.setDate(currentDate.getDate() + 1);
			limit++;
		}
		return days;
	};

	const calculateBusinessDaysLeft = (schedule, now) => {
		if (!Array.isArray(schedule)) return 0;
		const todayStr = now.toISOString().split('T')[0];
		let count = 0;

		for (const item of schedule) {
			if (!item.is_open) continue;

			// Handle API property mismatch (date vs full_date)
			const itemDate = item.date || item.full_date;
			if (!itemDate) continue;

			if (itemDate > todayStr) {
				count++;
			} else if (itemDate === todayStr && item.close_time) {
				const [cHours, cMinutes] = item.close_time.split(':').map(Number);
				const closeDate = new Date(now);
				closeDate.setHours(cHours, cMinutes, 0, 0);
				if (now < closeDate) count++;
			}
		}
		return count;
	};

	const getWeeklyScope = (schedule, now) => {
		if (!Array.isArray(schedule) || schedule.length === 0) return null;

		const getSunday = (d) => {
			const date = new Date(d);
			const day = date.getDay();
			const diff = date.getDate() - day;
			date.setDate(diff);
			date.setHours(0, 0, 0, 0);
			return date;
		};

		const filterWeek = (startOfWeek) => {
			const nextWeek = new Date(startOfWeek);
			nextWeek.setDate(nextWeek.getDate() + 7);
			return schedule.filter(d => {
				const dateStr = d.date || d.full_date;
				if (!dateStr) return false;
				const date = parseDateString(dateStr + ' 00:00');
				return date >= startOfWeek && date < nextWeek;
			});
		};

		let currentWeekStart = getSunday(now);

		for (let w = 0; w < 4; w++) {
			let weekDays = filterWeek(currentWeekStart);
			weekDays.sort((a, b) => (a.date || a.full_date).localeCompare(b.date || b.full_date));

			if (weekDays.length > 0) {
				// FIX: Do not segment. Identify ALL open business days in this week.
				const openDays = weekDays.filter(d => d.is_open || (d.open_time && d.close_time));

				if (openDays.length > 0) {
					const first = openDays[0];
					const last = openDays[openDays.length - 1];

					const firstDate = first.date || first.full_date;
					const lastDate = last.date || last.full_date;

					const start = parseDateString(`${firstDate} ${first.open_time || '08:00'}`);
					const end = parseDateString(`${lastDate} ${last.close_time || '16:30'}`);

					if (start && end && now < end) {
						return {
							scopeStart: start,
							scopeEnd: end,
							scopeDays: openDays,
							isCurrentSaleWeek: (now >= start && now <= end)
						};
					}
				}
			}
			currentWeekStart.setDate(currentWeekStart.getDate() + 7);
		}
		return null;
	};

	// --- Global State ---
	let sectionState = {
		targetDate: null,
		businessDaysLeft: null,
		isCurrentSaleWeek: false,
		isActive: true, // Used to toggle visibility if expired
		schedule: [],
		saleStart: null,
		saleEnd: null,
		hasInitialized: false
	};

	// --- Rendering ---
	const updateSectionState = () => {
		const now = new Date();

		// 0. Calculate Logic Scope
		// Priority: sectionState (Fetched/Partial) > origoSaleData (Full Campaign)
		let logicSchedule = (sectionState.schedule && sectionState.schedule.length > 0)
			? sectionState.schedule
			: (origoSaleData.schedule || []);

		let _saleStart = parseDateString(origoSaleData.start_date);
		let _saleEnd = parseDateString(origoSaleData.end_date);
		let _isCurrentSaleWeek = false;

		if (_saleStart && _saleEnd) {
			_isCurrentSaleWeek = now >= _saleStart && now <= _saleEnd;
		}

		const weeklyScope = getWeeklyScope(logicSchedule, now);

		if (weeklyScope?.scopeStart && weeklyScope?.scopeEnd) {
			_saleStart = weeklyScope.scopeStart;
			_saleEnd = weeklyScope.scopeEnd;
			_isCurrentSaleWeek = weeklyScope.isCurrentSaleWeek;
		}

		// 1. Calculate Business Days (from Logic Scope)
		const businessDaysLeft = calculateBusinessDaysLeft(weeklyScope?.scopeDays || logicSchedule, now);

		// 2. Determine Target Date & Status
		let targetDate = _isCurrentSaleWeek ? _saleEnd : _saleStart;

		// Force countdown to end if strictly 1 business day left
		if (!_isCurrentSaleWeek && businessDaysLeft === 1) {
			targetDate = _saleEnd;
			_isCurrentSaleWeek = true;
		}

		// Update State
		sectionState.targetDate = targetDate;
		sectionState.saleStart = _saleStart;
		sectionState.saleEnd = _saleEnd; // Useful for templating
		sectionState.businessDaysLeft = businessDaysLeft;
		sectionState.isCurrentSaleWeek = _isCurrentSaleWeek;
	};

	const renderSection = () => {
		const now = new Date();

		const { targetDate, businessDaysLeft, isCurrentSaleWeek, saleStart, saleEnd } = sectionState;

		if (!targetDate) return; // Not ready

		let remainingMs = Math.max(0, targetDate - now);

		// Time Units
		const rMin = Math.ceil(remainingMs / 60000);
		let timeValue, timeUnitKey, pluralWord, singularWord;

		if (rMin < 60) {
			timeValue = rMin;
			timeUnitKey = 'minutes';
			pluralWord = 'minuten';
			singularWord = 'minuut';
		} else {
			const rHours = Math.ceil(remainingMs / 3600000);
			if (rHours <= 24) {
				timeValue = rHours;
				timeUnitKey = 'hours';
				pluralWord = 'uur';
				singularWord = 'uur';
			} else {
				// Calendar Days
				let rDays = Math.ceil(remainingMs / 86400000);
				// Override with Business Days if active
				if (businessDaysLeft >= 1 && isCurrentSaleWeek) {
					rDays = businessDaysLeft;
				}
				timeValue = rDays;
				timeUnitKey = 'days';
				pluralWord = 'dagen';
				singularWord = 'dag';
			}
		}

		const timeHtml = `<span class="days-remaining">${timeValue}</span> ${timeValue === 1 ? singularWord : pluralWord}`;

		let templateText = 'Deze week nog maar <br> [time_remaining] leegverkoop!'; // Absolute Fallback

		if (isCurrentSaleWeek) {
			if (origoSaleData.from_start_text) templateText = origoSaleData.from_start_text;
			else templateText;
		} else {
			// Pending / Future
			if (origoSaleData.until_start_text) templateText = origoSaleData.until_start_text;
			else if (saleStart) {
				const isSameDay = now.getFullYear() === saleStart.getFullYear() &&
					now.getMonth() === saleStart.getMonth() &&
					now.getDate() === saleStart.getDate();

				if (isSameDay) {
					templateText = 'Onze leegverkoop start <br> over [time_remaining]!';
				} else {
					templateText = `Onze leegverkoop start <br> op ${new Date(saleStart).toLocaleDateString('nl-NL', {
						weekday: 'long', day: 'numeric', month: 'long'
					})}`;
				}
			}
		}

		const messageEl = document.getElementById('fire-sale-message');

		if (messageEl) {
			const formattedDate = saleStart ? new Date(saleStart).toLocaleDateString('nl-NL', {
				weekday: 'long', day: 'numeric', month: 'long'
			}) : '';

			messageEl.innerHTML = templateText
				.replace(/\[time_remaining]/g, timeHtml)
				.replace(/\[date]/g, formattedDate);
		}
	};

	const renderScheduleList = () => {
		// This acts as the visual schedule renderer, likely only needs to run once or on low frequency
		// However, it relies on 'isPast' logic which changes with time.
		// We can run this every minute along with state update.

		let displaySchedule = sectionState.schedule;
		if (!displaySchedule || displaySchedule.length === 0) {
			// Try fallback generation if we have dates
			if (sectionState.saleStart && sectionState.saleEnd) {
				displaySchedule = generateFallbackDays(sectionState.saleStart, sectionState.saleEnd);
			} else {
				return;
			}
		}

		const daysContainer = document.getElementById("fire-sale-days");
		if (!daysContainer) return;

		const daysData = displaySchedule || [];

		if (daysData.length > 0) {
			daysContainer.innerHTML = '';
			const now = new Date(); // use current time for rendering past/future

			daysData.forEach(day => {
				if (day.day_name === 'Zondag') return;

				let isPast = false;

				if (day.close_time === null) {
					isPast = true;
				} else {
					let closeDate = null;
					const [h, min] = (day.close_time || '00:00').split(':').map(Number);

					if (day.date) {
						const [y, m, d] = day.date.split('-').map(Number);
						closeDate = new Date(y, m - 1, d, h, min, 0);
					} else {
						const mIdx = dutchMonths[day.month_name.toLowerCase()];
						if (mIdx !== undefined) {
							const candidates = [-1, 0, 1].map(offset => {
								return new Date(currentYear + offset, mIdx, day.day_number, h, min, 0);
							});
							closeDate = candidates.reduce((a, b) => Math.abs(b - now) < Math.abs(a - now) ? b : a);
						}
					}

					if (closeDate && now > closeDate) {
						isPast = true;
					}
				}

				const div = document.createElement('div');
				div.className = 'fire-sale-day' + (isPast ? ' past' : '');
				const shortName = day.day_name.substring(0, 2).toUpperCase();
				div.innerHTML = `<span class="week-day">${shortName}</span><span class="month-day">${day.day_number}</span>`;
				daysContainer.appendChild(div);
			});
		}
	};

	// --- Main Execution ---

	const startFireSale = () => {
		const messageEl = document.getElementById("fire-sale-message");
		const daysContainer = document.getElementById("fire-sale-days");

		if (!messageEl || !daysContainer) return;

		// Fetch Schedule via Shared API
		if (window.OrigoApi && window.OrigoApi.fetchCached) {
			window.OrigoApi.fetchCached(apiUrl)
				.then(data => data.schedule || data.days || [])
				.then(scheduleData => {
					sectionState.schedule = scheduleData;
					updateSectionState();
					renderSection();
					renderScheduleList();
				})
				.catch(err => {
					console.error("Failed to fetch schedule", err);
					updateSectionState(); // Will try fallback logic if dates exist
					renderSection();
					renderScheduleList();
				})
				.finally(() => {
					// Start Intervals
					if (!sectionState.hasInitialized) {
						setInterval(renderSection, 1000);
						setInterval(() => {
							updateSectionState();
							renderScheduleList();
						}, 60000);
						sectionState.hasInitialized = true;
					}
				});

			// Initial State calc (pre-fetch)
			updateSectionState();
			renderSection();
		} // Close window.OrigoApi check

	};

	// AJAX Cache Bypass
	if (typeof fireSaleAjax !== 'undefined') {
		fetch(fireSaleAjax.ajaxurl + '?action=get_fire_sale_data&nonce=' + fireSaleAjax.nonce)
			.then(response => response.json())
			.then(response => {
				if (response.success && response.data) {
					// Update global data with fresh server data
					Object.assign(origoSaleData, response.data);
				}
			})
			.catch(err => console.error('Error fetching fire sale section data:', err))
			.finally(() => {
				startFireSale();
			});
	} else {
		startFireSale();
	}
});
